import { render } from "./LXTerminals.vue?vue&type=template&id=f25fc384&scoped=true"
import script from "./LXTerminals.vue?vue&type=script&lang=js"
export * from "./LXTerminals.vue?vue&type=script&lang=js"

import "./LXTerminals.vue?vue&type=style&index=0&id=f25fc384&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f25fc384"

export default script